import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { FaSave, FaUserCircle } from "react-icons/fa";
import "./Production Schedule.css";
import { Api } from "../services/api";
import { InputText } from "primereact/inputtext";

import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { amber, green, red } from "@mui/material/colors";
import { color } from "framer-motion";

const Dashbord = ({ typeOfData }) => {
  const [projects, setProjects] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [totalEstiMated, setTotalEstiMated] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [selectOnStartDate, setSelectOnStartDate] = useState("2023-01-01");
  const [selectOnEndDate, setSelectOnEndDate] = useState("2025-12-31");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [showFsaColumns, setShowFsaColumns] = useState(false);

  const [selectedProject, setSelectedProject] = useState(null);

  const toast = useRef(null);
  const projectsRef = useRef(projects);

  useEffect(() => {
    projectsRef.current = projects;
  }, [projects]);

  useEffect(() => {
    getDashboardData();
  }, [typeOfData]);

  // *-----------------
  const openEditModal = () => {
    setIsModalOpen(true);
  };

  const closeModelAdd = (w) => {
    setIsModalOpen(false);
    // getDashboardData();
  };

  const getMonthFillOuts = (rowData, col) => {
    if (
      rowData.projectType === "y Workload by Job/Hours" ||
      rowData.projectType === "x Workload by Job" ||
      rowData.projectType === "z Workload by Hours"
    ) {
      return getStyle(rowData, col);
    }

    const val = rowData[col] ? rowData[col].toString() : "";
    if (!val) return "";

    const types = [];

    // Check for PC (Estimation)
    if (val.includes("PC")) {
      types.push({
        type: 'PC',
        title: 'Pre-Construction / Estimation',
        // borderStyle: 'solid',
        // color: "#" + rowData.pre_con_ColorCode 
        color: amber[500]
      });
    }
    // Check for PM (Construction)
    if (val.includes("PM")) {
      types.push({
        type: 'PM',
        title: 'Construction Started',
        // borderStyle: 'solid',
        // color: "#" + rowData.pMColorCode 
        color: green[500]
      });
    }

    if (types.length === 0) return "";

    const width = 100 / types.length;

    const getTextColor = (hex) => {
      if (!hex) return "#000000";
      const c = hex.replace('#', '');
      const r = parseInt(c.substr(0, 2), 16);
      const g = parseInt(c.substr(2, 2), 16);
      const b = parseInt(c.substr(4, 2), 16);
      // Calculate brightness using YIQ formula
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? "#000000" : "#FFFFFF";
    };

    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          padding: 0,
          margin: 0,
          display: "flex",
          boxSizing: 'border-box'
        }}
      >
        {types.map((item, index) => {
          const textColor = getTextColor(item.color);
          return (
            <div
              key={index}
              style={{
                height: "100%",
                width: `${width}%`,
                backgroundColor: item.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "bold",
                color: textColor,
                overflow: "hidden",
                whiteSpace: "nowrap",
                boxSizing: 'border-box',
                borderTop: `1px ${item.borderStyle} #000000`,
                borderBottom: `1px ${item.borderStyle} #000000`
              }}
              title={item.title}
            >
            </div>
          )
        })}
      </div>
    );
  };

  const getDashboardData = () => {
    setIsLoading(true);
    const token = localStorage.getItem("authToken");

    // Create headers with token if it exists
    const headers = {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
      "Cache-Control": "no-cache",
    };

    console.log("typeOfData--", typeOfData);
    var url = Api.API_BASE_URL + "get-production-schedule";
    if (typeOfData == "completed") {
      url = Api.API_BASE_URL + "completed-jobs";
    }
    if (typeOfData == "archived") {
      url = Api.API_BASE_URL + "project-archive";
    }
    axios
      .get(url, { headers })
      .then((response) => {
        const rawResult = response.data.result || [];
        const monthCols = response.data.monthList || [];

        // Group by Project Type
        const groups = {};
        rawResult.forEach(item => {
          if (!groups[item.projectType]) groups[item.projectType] = [];
          groups[item.projectType].push(item);
        });

        const finalProcessedData = [];

        // Helper to create summary row
        const createRow = (type, pMName) => {
          const newRow = {
            projectType: type,
            pM: pMName,
            id: `frontend_${type.replace(/\s/g, '')}_${pMName.replace(/\s/g, '')}_${Math.random()}`
          };
          monthCols.forEach(m => newRow[m] = '');
          return newRow;
        };

        Object.keys(groups).forEach(type => {
          const groupData = groups[type];

          if (type === "x Workload by Job") {
            // 1. Identify and extract specific rows (from API or frontend)
            let pmAvailable = groupData.find(r => r.pM === "PM Available");
            let jobsHandle = groupData.find(r => r.pM === "Jobs Handle");
            let pmCapacity = groupData.find(r => r.pM === "PM Capacity");
            let pmPlusMinus = groupData.find(r => r.pM === "PM +/-");
            let totalContract = groupData.find(r => r.pM === "Total Contract Jobs");

            // 2. Filter out the special rows from the main list so we can re-append them in correct order
            //    (We keep Total Contract in the main list, assuming it should stay where it is)
            const mainRows = groupData.filter(r =>
              !["PM Available", "Jobs Handle", "PM Capacity", "PM +/-"].includes(r.pM)
            );

            // 3. Ensure mandatory rows exist (create if missing from API)
            if (!pmAvailable) pmAvailable = createRow(type, "PM Available");
            if (!jobsHandle) jobsHandle = createRow(type, "Jobs Handle");
            if (!pmCapacity) pmCapacity = createRow(type, "PM Capacity");
            if (!pmPlusMinus) pmPlusMinus = createRow(type, "PM +/-");

            // 4. Perform Initial Calculation for all columns
            monthCols.forEach(m => {
              const valAvailable = parseFloat(pmAvailable[m]) || 0;
              const valHandle = parseFloat(jobsHandle[m]) || 0;
              const valContract = totalContract ? (parseFloat(totalContract[m]) || 0) : 0;

              // Calculate Capacity: Available * Handle
              const capacity = valAvailable * valHandle;
              pmCapacity[m] = capacity;

              // Calculate +/-: Total Contract - Capacity
              pmPlusMinus[m] = valContract - capacity;
            });

            // 5. Append in the desired strict order at the bottom of the group
            finalProcessedData.push(...mainRows);
            finalProcessedData.push(pmAvailable);
            finalProcessedData.push(jobsHandle);
            finalProcessedData.push(pmCapacity);
            finalProcessedData.push(pmPlusMinus);
          } else {
            finalProcessedData.push(...groupData);
          }
        });

        setProjects(finalProcessedData);
        setIsLoading(false);
        setMonthList(response.data.monthList);

        if (response.data.setting) {
          if (response.data.setting.startDate != null) {
            let timestamp = new Date(response.data.setting.startDate);

            if (!isNaN(timestamp.getTime())) {
              var formData = timestamp.toISOString().split("T")[0];
              setSelectOnStartDate(formData);
            }
          }
          if (response.data.setting.endDate != null) {
            let timestamp = new Date(response.data.setting.endDate);

            if (!isNaN(timestamp.getTime())) {
              var formData = timestamp.toISOString().split("T")[0];
              setSelectOnEndDate(formData);
            }
          }
        }

        // setSelectOnEndDate(response.data.setting.endDate)
        let total = 0;
        response.data.result.forEach((element) => {
          if (
            element.esitmatedSales !== 0 &&
            element.esitmatedSales !== "" &&
            element.esitmatedSales !== null
          ) {
            total += parseInt(element.esitmatedSales);
          }
        });
        setTotalEstiMated(total);

        var dea = [];
        response.data.result.forEach((element) => {
          const isNameExist = dea.some(
            (item) => item.projectType === element.projectType
          );
          if (isNameExist) {
            console.log("exist");
          } else {
            dea.push(element);
          }
        });
        setExpandedRows(dea);
      })

      .catch((error) => {
        console.error("Error fetching projects:", error);
        setIsLoading(false);
        // setExpandedRows();
      });
  };

  const calculateProjectTotal = (name) => {
    let total = 0;
    const te = [];

    if (projects) {
      for (let row of projects) {
        if (row.projectType === name) {
          if (
            row.esitmatedSales !== null &&
            row.esitmatedSales !== "" &&
            !isNaN(parseInt(row.esitmatedSales))
          ) {
            total += parseInt(row.esitmatedSales);
          }
        }
      }
    }
    if (total === 0) {
      total = "";
    }

    return total;
  };

  const headerTemplate = (data) => {
    var t = data.projectType;

    if (data.projectType === "x Workload by Job") {
      t = "Workload by Job";
    } else if (data.projectType === "z Workload by Hours") {
      t = "Workload by Hours";
    } else if (data.projectType === "y Workload by Job/Hours") {
      t = "Workload by Job/Hours";
    } else if (data.projectType === "Active Commercial") {
      t = "Contract Commercial";
    } else if (data.projectType === "Active Custom Homes") {
      t = "Contract Custom Homes";
    } else if (data.projectType === "Active Multi Family") {
      t = "Contract Multi Family";
    } else if (data.projectType === "Active Renovations") {
      t = "Contract Renovations";
    } else if (data.projectType === "Active Tenant Improvements") {
      t = "Contract Tenant Improvements";
    }

    const total = calculateProjectTotal(data.projectType);
    const formattedTotal = formatCurrency(total);
    const showTotal = total !== "" && total !== 0;

    return (
      <React.Fragment>
        <th
          colSpan="1"
          className="no-horizontal-scroll p-frozen-column myheader"
          style={{ border: "none" }}
        >
          <div className="flex align-items-center justify-content-between w-full pr-4">
            <span style={{ overflowX: "hidden", whiteSpace: "nowrap" }}>
              <i
                className="pi pi-circle-fill"
                style={{ color: "#" + data.projectTypeColorCode }}
              ></i>{" "}
              {t}
            </span>
            {showTotal && (
              <span className="font-bold text-sm text-700">
                {formattedTotal}
              </span>
            )}
          </div>
        </th>
      </React.Fragment>
    );
  };

  const showDate = (date) => {
    if (date == "0000-00-00") {
      return "";
    }
    if (date == "0/0") {
      return "";
    }
    if (date == null) {
      return "";
    }

    let timestamp = new Date(date);

    if (!isNaN(timestamp.getTime())) {
      date = timestamp.toISOString().split("T")[0];
    }
    return date;
  };

  function checkDateForMonthe(givenDate, monthColor) {
    if (givenDate == "0000-00-00") {
      return "";
    }
    if (givenDate == "0/0") {
      return "";
    }
    if (givenDate == null || givenDate == "null") {
      return "";
    }

    const currentDate = new Date();
    const dateToCheck = new Date(givenDate);
    if (monthColor == "Y") {
      return <span style={{ color: "green" }}>{givenDate}</span>;
    }

    if (dateToCheck < currentDate) {
      return <span style={{ color: "red" }}>{givenDate}</span>;
    }

    return givenDate;
  }

  const showDevide = (date, projectType = "") => {
    if (
      projectType === "y Workload by Job/Hours" ||
      projectType === "x Workload by Job" ||
      projectType === "z Workload by Hours"
    ) {
      return "";
    }
    if (date === "" || date === null) {
      return "0/0";
    }
    return date;
  };

  const getColorForDate = (date) => {
    const [day, month] = date.split("/").map(Number);
    return day > 0 || month > 0 ? "red" : "#00D26A";
  };

  const getBackgroundColorForDate = (date) => {
    const [day, month] = date.split("/").map(Number);
    return day > 0 || month > 0 ? "#fcd9d9" : "#c9f5d2";
  };

  const getBorderColorForDate = (date) => {
    const [day, month] = date.split("/").map(Number);
    return day > 0 || month > 0 ? "red" : "green"; // Change colors as needed
  };

  const balanceTemplate = (rowData) => {
    if (rowData == null) {
    }
    if (rowData === "") {
      return "";
    }
    if (typeof rowData == "string") {
      rowData = parseInt(rowData);
    }
    if (rowData == 0) {
      return "";
    }
    return <span className="font-bold">{formatCurrency(rowData)}</span>;
  };

  const formatCurrency = (value) => {
    if (value == null) {
      return "";
    }
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const getPMNameAndIcon = (projectType, projectTypeColorCode) => {
    return (
      <span>
        <FaUserCircle style={{ color: "#" + projectTypeColorCode }} />{" "}
        {projectType}
      </span>
    );
  };

  const StartDateAndEndDateSelect = () => {
    const startDate = new Date(selectOnStartDate);
    const endDate = new Date(selectOnEndDate);

    if (startDate > endDate) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Start date should be before end date.",
      });
      return;
    }

    updateDateInBackend(selectOnStartDate, selectOnEndDate);

    localStorage.setItem("startYear", selectOnStartDate);
    localStorage.setItem("endYear", selectOnEndDate);
  };

  const updateDateInBackend = (startDate, endDate) => {
    setIsLoading(true);
    var _body = {
      startDate: startDate,
      endDate: endDate,
    };
    const token = localStorage.getItem("authToken");

    // Create headers with token if it exists
    const headers = {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    };
    fetch(Api.API_BASE_URL + "change-startDate-endDate/1", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false);
        getDashboardData();
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  };

  // *-------------------------
  const toggleFsaColumns = () => {
    setShowFsaColumns(!showFsaColumns);
  };
  // !-------------------------

  const header = (
    <div className="dashboard-toolbar">
      <div className="kpi-card">
        <span className="kpi-label">TOTAL ESTIMATED SALES</span>
        <strong className="kpi-value">{balanceTemplate(totalEstiMated)}</strong>
      </div>

      <div className="toolbar-controls">
        <div className="control-group">
          <label>Start Date</label>
          <InputText
            type="date"
            className="modern-input"
            value={selectOnStartDate}
            onChange={(e) => setSelectOnStartDate(e.target.value)}
          />
        </div>
        <div className="control-group">
          <label>End Date</label>
          <InputText
            type="date"
            className="modern-input"
            value={selectOnEndDate}
            onChange={(e) => setSelectOnEndDate(e.target.value)}
          />
        </div>

        <div className="action-buttons">
          <button
            type="button"
            title="Save Date"
            onClick={StartDateAndEndDateSelect}
            className="btn-modern btn-primary"
          >
            <FaSave size={16} />
            <span>Save</span>
          </button>

        </div>
      </div>
    </div>
  );

  const rowClass = (data) => {
    return {
      "bg-gray-200":
        data.pM === "Total Contract Jobs" ||
        data.pM === "PM Available" ||
        data.pM === "Jobs Handle" ||
        data.pM === "PM Capacity" ||
        data.pM === "PM +/-" ||
        data.pM === "Total FSA Jobs" ||
        data.pM === "Estimator Available" ||
        data.pM === "Estimator Capacity" ||
        data.pM === "Estimator +/-",
    };
  };

  const saveTimeoutRef = useRef(null);
  const pendingSavePayload = useRef(null);

  const debouncedSavePmCapacity = (pmCapacity, pmAvailable, month) => {
    // Update the latest values to be saved
    pendingSavePayload.current = { pmCapacity, pmAvailable, month };

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(async () => {
      if (!pendingSavePayload.current) return;

      // Read the LATEST values from the ref at the moment of execution
      const { pmCapacity, pmAvailable, month } = pendingSavePayload.current;

      try {
        const token = localStorage.getItem("authToken");

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        };

        console.log("Auto-saving PM Capacity...", { jobs_handle: pmCapacity, pm_available: pmAvailable, month: month });

        const response = await fetch(Api.API_BASE_URL + 'save-pm-capacity', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            jobs_handle: pmCapacity,
            pm_available: pmAvailable,
            month: month,
            apply_future_months: 23
          }),
        });

        if (!response.ok) {
          console.error("Failed to auto-save PM settings:", response.statusText);
        } else {
          console.log("PM settings saved successfully.");
        }
      } catch (err) {
        console.error("Error auto-saving PM settings:", err);
      }
    }, 1000); // 1-second debounce
  };

  const onCellEdit = (rowData, field, val) => {
    // Trigger Auto-Save Side Effect
    if (rowData.pM === "PM Available" || rowData.pM === "Jobs Handle") {
      let currentAvailable = 0;
      let currentCapacity = 0; // This maps to "Jobs Handle" ("Number of Jobs PM can handle")
      const parse = (v) => parseFloat(v) || 0;
      const currentProjects = projectsRef.current; // Use Ref to avoid stale closure issues

      if (rowData.pM === "PM Available") {
        currentAvailable = parse(val);
        // Get partner value (Jobs Handle) from current state
        const handleRow = currentProjects.find(p => p.projectType === rowData.projectType && p.pM === "Jobs Handle");
        if (handleRow) {
          currentCapacity = parse(handleRow[field]);
        }
      } else {
        currentCapacity = parse(val);
        // Get partner value (PM Available) from current state
        const availRow = currentProjects.find(p => p.projectType === rowData.projectType && p.pM === "PM Available");
        if (availRow) {
          currentAvailable = parse(availRow[field]);
        }
      }

      debouncedSavePmCapacity(currentCapacity, currentAvailable, field);
    }

    setProjects((prevProjects) => {
      // 1. Determine columns to update (Current + Next 23 months)
      const startIndex = monthList.indexOf(field);
      // Valid month field? Update current + next 23 (or to end of list)
      const columnsToUpdate = (startIndex !== -1)
        ? monthList.slice(startIndex, startIndex + 24)
        : [field];

      // 2. Clone current state
      const updatedProjects = [...prevProjects];

      // 3. Identify indices for the related rows in this Project Type group
      //    We rely on the fact that these rows exist for the group
      const projectType = rowData.projectType;

      const availableIndex = updatedProjects.findIndex(p => p.projectType === projectType && p.pM === "PM Available");
      const jobsHandleIndex = updatedProjects.findIndex(p => p.projectType === projectType && p.pM === "Jobs Handle");
      const capacityIndex = updatedProjects.findIndex(p => p.projectType === projectType && p.pM === "PM Capacity");

      // 4. Update the User-Edited Row (Available or Jobs Handle)
      //    Determine which index corresponds to rowData
      const targetIndex = (rowData.pM === "PM Available") ? availableIndex : jobsHandleIndex;

      if (targetIndex !== -1) {
        updatedProjects[targetIndex] = { ...updatedProjects[targetIndex] };

        // Apply value to all target columns
        columnsToUpdate.forEach(col => {
          updatedProjects[targetIndex][col] = val;
        });
      }

      // 5. Recalculate PM Capacity AND PM +/- for the same columns
      const totalContractIndex = updatedProjects.findIndex(p => p.projectType === projectType && p.pM === "Total Contract Jobs");
      const pmPlusMinusIndex = updatedProjects.findIndex(p => p.projectType === projectType && p.pM === "PM +/-");

      if (availableIndex !== -1 && jobsHandleIndex !== -1 && capacityIndex !== -1) {
        updatedProjects[capacityIndex] = { ...updatedProjects[capacityIndex] };
        if (pmPlusMinusIndex !== -1) {
          updatedProjects[pmPlusMinusIndex] = { ...updatedProjects[pmPlusMinusIndex] };
        }

        columnsToUpdate.forEach(col => {
          const valAvailable = parseFloat(updatedProjects[availableIndex][col]) || 0;
          const valJobsHandle = parseFloat(updatedProjects[jobsHandleIndex][col]) || 0;
          const newCapacity = valAvailable * valJobsHandle;

          updatedProjects[capacityIndex][col] = newCapacity;

          // Recalculate PM +/- : Total Contract Jobs - PM Capacity
          if (totalContractIndex !== -1 && pmPlusMinusIndex !== -1) {
            const valTotalContract = parseFloat(updatedProjects[totalContractIndex][col]) || 0;
            const newPlusMinus = valTotalContract - newCapacity;
            updatedProjects[pmPlusMinusIndex][col] = newPlusMinus;
          }
        });
      }

      return updatedProjects;
    });
  };

  const getStyle = (e, col) => {
    let style = { padding: "0px" };
    const isAdmin = localStorage.getItem('isAdmin');

    if (e.pM === "PM Available" || e.pM === "Jobs Handle") {
      return (
        <InputText
          value={e[col] || ''}
          onChange={(event) => onCellEdit(e, col, event.target.value)}
          style={{ width: '100%', height: '30px', fontSize: '13px', textAlign: 'center', padding: 0 }}
          disabled={isAdmin !== 'Y'}
        />
      );
    }

    if (e.pM === "Vacant PM" || e.pM === "PM +/-") {
      if (e[col] < 0) {
        // style.border = '1px solid red';
        // style.backgroundColor = '#fcd9d9';
        style.color = "red"; // Set text color to white when background is red
        style.fontWeight = "bold";
      } else if (e[col] > 0) {
        style.color = "green"; // Set text color to white when background is red
        style.fontWeight = "bold";
      }
    } else {
      if (e[col] < 0) {
        // style.border = '1px solid red';
        // style.backgroundColor = '#fcd9d9';
        style.color = "red"; // Set text color to white when background is red
        style.fontWeight = "bold";
      }
    }

    if (e.pM === "PM +/-") {
      return <div style={style}>{e[col] > 0 ? "+" + e[col] : e[col]}</div>;
    } else return <div style={style}>{e[col]}</div>;
  };

  const hoursPerDay = (projectType, hour_per) => {
    if (
      projectType === "y Workload by Job/Hours" ||
      projectType === "x Workload by Job" ||
      projectType === "z Workload by Hours"
    ) {
      return "";
    }
    return hour_per;
  };

  function getFutureDate(dateString, monthsToAdd) {
    if (dateString == null) {
      return null;
    }

    const completionDate =
      dateString instanceof Date ? dateString : new Date(dateString);
    if (isNaN(completionDate)) {
      return null;
    }

    const futureDate = new Date(
      completionDate.setMonth(completionDate.getMonth() + monthsToAdd)
    );
    return futureDate.toISOString().split("T")[0];
  }

  /* --------------------------------------------------------------------------- */
  /* CSS GRID RENDER LOGIC (REPLACEMENT FOR DATATABLE) */
  /* --------------------------------------------------------------------------- */
  const getColumnsConfig = () => {
    const cols = [
      { field: "projectName", header: "Project Name", width: 300, frozen: true },
      // Project ID: existing code calls it 'p_id'
      // { field: "p_id", header: "Project ID", width: 120, frozen: true },
      // Use balanceTemplate logic for Sales
      { field: "esitmatedSales", header: "Est. Sales", width: 130, render: (r) => balanceTemplate(r.esitmatedSales) },
    ];

    // CONTACT DATE (with toggle button logic embedded in header if possible, or just next to it)
    // The previous header had a toggle button inside.
    const ContactDateHeader = (
      <div className="flex justify-content-between align-items-center" onClick={(e) => { e.stopPropagation(); toggleFsaColumns(); }} style={{ cursor: 'pointer' }}>
        <span>Contact Date</span>
        {showFsaColumns ? <MdKeyboardDoubleArrowLeft size={18} /> : <MdKeyboardDoubleArrowRight size={18} />}
      </div>
    );

    cols.push(
      { field: "contactDate", header: ContactDateHeader, width: 130, render: (r) => showDate(r.contactDate) }
    );

    if (showFsaColumns) {
      cols.push(
        { field: "contact_to_fsa_development", header: "Contact to FSA Dev", width: 130, render: (r) => showDevide(r.contact_to_fsa_development, r.projectType) },
        { field: "development_month_days", header: "Dev Month/Days", width: 120, render: (r) => showDate(r.development_month_days) },
        { field: "ContacttoFSAMonthsAndDays", header: "Contact to FSA", width: 130, render: (r) => showDevide(r.ContacttoFSAMonthsAndDays, r.projectType) },
        { field: "fsa_signed_date_em_playbook", header: "FSA SIGNED", width: 120, render: (r) => showDate(r.fsa_signed_date_em_playbook) },
        { field: "forecasted_building_date_em_playbook", header: "Planned BP Date", width: 180, render: (r) => showDate(r.forecasted_building_date_em_playbook) },
        { field: "building_permit_recieved_em_playbook", header: "BP Date", width: 160, render: (r) => showDate(r.building_permit_recieved_em_playbook) },
        { field: "actual_pre_con_month_by_day_em_playbook", header: "Actual Pre Con M/D", width: 180, render: (r) => showDevide(r.actual_pre_con_month_by_day_em_playbook, r.projectType) },
        {
          field: "of_pre_con_month_by_day_em_playbook", header: "# Pre Con Slippages", width: 180, render: (r) => {
            const date = showDevide(r.of_pre_con_month_by_day_em_playbook, r.projectType);
            if (!date) return "";
            return <div style={{ color: getColorForDate(date) }}>{date}</div>;
          }
        }
      )
    }

    cols.push(
      { field: "contractDate", header: "Contract Date", width: 130, render: (r) => showDate(r.contractDate) },
      { field: "FSAtoContractMonthsAndDays", header: "FSA to Contract", width: 160, render: (r) => showDevide(r.FSAtoContractMonthsAndDays, r.projectType) },
      { field: "actualStartDate", header: "Actual Start", width: 130, render: (r) => showDate(r.actualStartDate) },
      { field: "forecasted_complation_data_pm", header: "Planned Completion", width: 130, render: (r) => showDate(r.forecasted_complation_data_pm) },
      { field: "actualCompletionDate", header: "Actual Completion", width: 150, render: (r) => showDate(r.actualCompletionDate) },
      { field: "final_invoice_date", header: "Final Invoice", width: 150, render: (r) => showDate(r.final_invoice_date) },
      { field: "actual_slippage_of_month_dat_pm", header: "Actual # M/D", width: 130 },
      {
        field: "slippage_of_month_by_day_pm", header: "# M/D Slippages +/-", width: 130, render: (r) => {
          const date = showDevide(r.slippage_of_month_by_day_pm, r.projectType);
          if (!date) return "";
          return <div style={{ color: getColorForDate(date) }}>{date}</div>;
        }
      },
      { field: "monthLeft", header: "Months Left", width: 130 },
      { field: "hoursPerDay", header: "Hrs/Day", width: 130, render: (r) => hoursPerDay(r.projectType, r.hoursPerDay) },
      { field: "3Month", header: "3 Mo Warranty", width: 130, render: (r) => checkDateForMonthe(getFutureDate(r.actualCompletionDate, 3), r.month_3_color) || "" },
      { field: "6Month", header: "6 Mo Warranty", width: 130, render: (r) => checkDateForMonthe(getFutureDate(r.actualCompletionDate, 6), r.month_6_color) || "" },
      { field: "12Month", header: "12 Mo Warranty", width: 130, render: (r) => checkDateForMonthe(getFutureDate(r.actualCompletionDate, 12), r.month_12_color) || "" },
      {
        field: "pre_con_manager", header: "Pre-Con Mgr", width: 200, render: (r) => {
          if (!r.pre_con_manager) return "";
          return <span><FaUserCircle style={{ color: "#" + r.pre_con_ColorCode, marginRight: 4 }} />{r.pre_con_manager}</span>;
        }
      },
      { field: "pM", header: "Project Manager", width: 200, render: (r) => getPMNameAndIcon(r.pM, r.pMColorCode) }
    );

    // Dynamic Months
    monthList.forEach(m => {
      cols.push({
        field: m,
        // Replace spaces for cleaner layout if needed, logic copied from old code
        header: <div className="vertical-header-text" style={{ padding: "0 5px" }}>{typeof m === 'string' ? m.replace(" 20", " ") : m}</div>,
        width: 80,
        render: (r) => getMonthFillOuts(r, m)
      });
    });

    return cols;
  };

  const renderGrid = () => {
    const cols = getColumnsConfig();
    // Calculate grid template
    const gridTemplate = cols.map(c => `${c.width}px`).join(" ");



    const gridItems = [];
    let currentGroup = null;
    let lastPMValue = null;
    let workloadFSAHeaderAdded = false;
    let workloadConstructionHeaderAdded = false;

    // 1. HEADER ROW
    cols.forEach((col, idx) => {
      const isFrozen = col.frozen;
      const leftOffset = idx === 1 ? 300 : 0;
      const style = {
        width: col.width,
        left: isFrozen ? leftOffset : undefined,
        minWidth: col.width,
        gridColumn: idx + 1
      };

      let className = "ps-grid-cell ps-grid-header";
      if (idx === 0) className += " ps-col-sticky-1";
      if (idx === 1) className += " ps-col-sticky-2";

      gridItems.push(
        <div key={`head-${idx}`} className={className} style={style}>
          {col.header}
        </div>
      );
    });

    // 2. BODY
    projects.forEach((row, rIdx) => {
      const group = row.projectType;

      if (group !== currentGroup) {
        currentGroup = group;
        const total = calculateProjectTotal(group);
        const formattedTotal = (typeof formatCurrency === 'function') ? formatCurrency(total) : total;
        const showTotal = total !== "" && total !== 0;
        let tName = group;
        if (group === "x Workload by Job") tName = "Workload by Job";
        if (group === "z Workload by Hours") tName = "Workload by Hours";
        if (group === "y Workload by Job/Hours") tName = "Workload by Job/Hours";
        if (group === "Active Commercial") tName = "Contract Commercial";
        if (group === "Active Custom Homes") tName = "Contract Custom Homes";
        if (group === "Active Multi Family") tName = "Contract Multi Family";
        if (group === "Active Renovations") tName = "Contract Renovations";
        if (group === "Active Tenant Improvements") tName = "Contract Tenant Improvements";

        // SPLIT GROUP HEADER: 
        // 1. Sticky Label (Cols 1-2)
        gridItems.push(
          <div
            key={`group-label-${rIdx}`}
            className="ps-group-header-label"
            style={{ gridColumn: "1 / 3" }}
          >
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <i className="pi pi-circle-fill" style={{ color: "#" + row.projectTypeColorCode, marginRight: 8 }}></i>
              {tName}
            </div>
            {showTotal && <div style={{ fontWeight: "normal", marginLeft: 'auto', paddingRight: '12px' }}>{formattedTotal}</div>}
          </div>
        );

        // 2. Filler (Cols 3-End)
        gridItems.push(
          <div
            key={`group-filler-${rIdx}`}
            className="ps-group-header-filler"
            style={{ gridColumn: "3 / -1" }}
          >
            {/* Empty Background Filler */}
          </div>
        );
      }

      // Inject sub-section headers for "Workload by Job" group
      if (group === "x Workload by Job") {
        if (!workloadFSAHeaderAdded) {
          gridItems.push(
            <div key="sub-fsa-label" className="ps-sub-section-label" style={{ gridColumn: "1 / 3" }}>
              FSA Jobs
            </div>
          );
          gridItems.push(
            <div key="sub-fsa-filler" className="ps-sub-section-filler" style={{ gridColumn: "3 / -1" }}></div>
          );
          workloadFSAHeaderAdded = true;
        } else if (lastPMValue === "Total FSA Jobs" && !workloadConstructionHeaderAdded) {
          gridItems.push(
            <div key="sub-construction-label" className="ps-sub-section-label" style={{ gridColumn: "1 / 3" }}>
              Construction Jobs
            </div>
          );
          gridItems.push(
            <div key="sub-construction-filler" className="ps-sub-section-filler" style={{ gridColumn: "3 / -1" }}></div>
          );
          workloadConstructionHeaderAdded = true;
        }
      }

      cols.forEach((col, cIdx) => {
        const isFrozen = col.frozen;
        const leftOffset = cIdx === 1 ? 300 : 0;
        const style = {
          width: col.width,
          left: isFrozen ? leftOffset : undefined,
          minWidth: col.width,
          gridColumn: cIdx + 1
        };

        let className = "ps-grid-cell ps-grid-body-cell";
        if (cIdx === 0) className += " ps-col-sticky-1";
        if (cIdx === 1) className += " ps-col-sticky-2";

        // Content
        let content = row[col.field];
        if (col.render) {
          content = col.render(row);
        }
        if (col.field === 'projectName') {
          content = <div style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.projectName}>{row.projectName} {row.internal_job === "Y" ? "✅" : ""}</div>;
        }

        // Handle background color for special rows (simulating rowClass)
        const isHighlighted =
          row.pM === "Total Contract Jobs" ||
          row.pM === "PM Available" ||
          row.pM === "Jobs Handle" ||
          row.pM === "PM Capacity" ||
          row.pM === "PM +/-" ||
          row.pM === "Total FSA Jobs" ||
          row.pM === "Estimator Available" ||
          row.pM === "Estimator Capacity" ||
          row.pM === "Estimator +/-";

        // INLINE STYLE FIX
        // We use correct background inheritance
        const finalStyle = {
          ...style,
          backgroundColor: style.backgroundColor || (isHighlighted ? '#f8f9fa' : 'white')
        };

        gridItems.push(
          <div key={`r-${rIdx}-c-${cIdx}`} className={className} style={finalStyle}>
            {content}
          </div>
        );
      });

      lastPMValue = row.pM;
    });

    return (
      <>

        <div style={{ position: 'relative', width: '100%', height: '100%', flex: 1, minHeight: 0 }}>
          <div className="ps-scroll-container">
            <div className="ps-grid-container" style={{ gridTemplateColumns: gridTemplate }}>
              {gridItems}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-content-card">
        {header}
        {isLoading ? (
          <div className="loading-spinner">
            Loading...
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="table-responsive-wrapper">
            {/* ------------------------------------------------------------------------- */}
            {/* CSS GRID IMPLEMENTATION */}
            {/* ------------------------------------------------------------------------- */}
            <div className="production-schedule-table" style={{ overflow: "auto" }}>
              {renderGrid()}
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default Dashbord;
